export default {
    default: {
        title: 'МойОпрос: опросы онлайн, платные опросы за деньги',
        description: 'Проходите платные опросы онлайн и получайте деньги на карту. Простой заработок в интернете без вложений вместе с МойОпрос.'
    },
    '/?dialog=contact-us': {
        title: 'МойОпрос: обратная связь. Написать в поддержку онлайн-опросника',
        description: 'Напишите в поддержку МойОпрос — задайте вопросы о платных опросах, решите проблемы с аккаунтом и узнайте, как заработать больше на опросах онлайн.'
    },
    '/?dialog=login': {
        title: 'МойОпрос: вход в аккаунт, личный кабинет интернет опросов',
        description: 'Вход в личный кабинет МойОпрос. Участвуйте в опросах онлайн, зарабатывайте деньги и выводите вознаграждения на карту или электронный кошелёк.'
    },
    '/?dialog=signup': {
        title: 'МойОпрос: зарегистрируйтесь и начните получать деньги за опросы',
        description: 'Регистрация в МойОпрос за пару кликов. Получайте деньги за участие в опросах, зарабатывайте онлайн и выводите доход удобным способом.'
    },
    '/ru/': {
        title: 'МойОпрос: онлайн-опросы, интернет опросы за деньги, платные опросы',
        description: 'Опросы онлайн за деньги: +50 рублей за платные опросы. Получай деньги за участие в опросах, выводи на карту и зарабатывай в интернете с МойОпрос.'
    },
    '/ru/?dialog=contact-us': {
        title: 'МойОпрос: обратная связь. Написать в поддержку онлайн-опросника',
        description: 'Напишите в поддержку МойОпрос — задайте вопросы о платных опросах, решите проблемы с аккаунтом и узнайте, как заработать больше на опросах онлайн.'
    },
    '/ru/?dialog=login': {
        title: 'МойОпрос: вход в аккаунт, личный кабинет интернет опросов',
        description: 'Вход в личный кабинет МойОпрос. Участвуйте в опросах онлайн, зарабатывайте деньги и выводите вознаграждения на карту или электронный кошелёк.'
    },
    '/ru/?dialog=signup': {
        title: 'МойОпрос: регистрация в личном кабинете интернет-опросника',
        description: 'Зарегистрируйтесь в личном кабинете интернет-опросника МойОпрос и начните зарабатывать. Регистрация в пару кликов, быстрый вывод денег и реальные отзывы.'
    },
};